module.exports = __webpack_public_path__ + "static/vr-5-1-18d19749bd719a20ea6767b771ad9bd8.jpeg";